import React from 'react';
import PropTypes from 'prop-types';
// material
import { Box, Typography, Modal, FormControl, Button, TextField } from '@mui/material';

import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';

import { DeviceEventRequestByServer } from '../../../network/Device';
import { parseValidationErrorMessage } from '../../../utils/Utilities';

// ----------------------------------------------------------------------
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 300,
  maxWidth: 500,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

const DeviceSchema = Yup.object().shape({
  amount: Yup.string().required('Required')
});

TestSoundBoxPaymentModal.propTypes = {
  opneAssignedModal: PropTypes.bool,
  handleClose: PropTypes.func,
  onAction: PropTypes.func,
  selectedMerchant: PropTypes.string
};

export default function TestSoundBoxPaymentModal({
  opneAssignedModal,
  handleClose,
  onAction,
  selectedMerchant
}) {
  const addDeviceFormik = useFormik({
    initialValues: {
      amount: ''
    },
    validationSchema: DeviceSchema,
    onSubmit: () => {
      sendDummyPayment();
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = addDeviceFormik;

  function sendDummyPayment() {
    DeviceEventRequestByServer(
      `test_${selectedMerchant?.deviceId}`,
      selectedMerchant?.deviceId,
      'DEVICE_SPEAK_TXN',
      [`${addDeviceFormik?.values?.amount}`],
      new Date().getTime()
    )
      .then((_res) => {
        handleClose();
        onAction('Payment sent successfully');
      })
      .catch((err) => {
        onAction(parseValidationErrorMessage(err));
      });
  }
  return (
    <Box>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <FormikProvider value={addDeviceFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={style}>
              <Typography sx={{ fontSize: 18, fontWeight: 900 }}>
                Send dummy payment on <br /> {selectedMerchant?.name}'s AudioCube
              </Typography>

              <div>
                <FormControl fullWidth sx={{ mb: 3, mt: 3 }}>
                  <TextField
                    id="amount"
                    name="amount"
                    label="amount "
                    type="number"
                    {...getFieldProps('amount')}
                    error={Boolean(touched.amount && errors.amount)}
                    helperText={touched.amount && errors.amount}
                  />
                </FormControl>
              </div>
              <Button variant="contained" type="submit" fullWidth size="large">
                Send
              </Button>
            </Box>
          </Form>
        </FormikProvider>
      </Modal>
    </Box>
  );
}
